export default __webpack_public_path__ + "static/media/Goldspar Satin Fernissa.17f12867.jpg";